const MEGA_NAV_SELECTOR = '.js-menu-item.is-mega'
const MAIN_NAV_SELECTOR = '.js-navigation'

class MegaNav extends HTMLElement {
  mainNav = null
  constructor () {
    super()
    this.init()
  }

  init () {
    this.mainNav = this.closest(MAIN_NAV_SELECTOR)
    const megaNavItems = Array.prototype.slice.call(this.querySelectorAll(MEGA_NAV_SELECTOR))
    megaNavItems.forEach(megaNavItem => {
      megaNavItem.addEventListener('mouseenter', this.handleMouseEnter)
      megaNavItem.addEventListener('mouseleave', this.handleMouseLeave)
    })
  }

  handleMouseEnter = () => {
    if (this.mainNav) { this.mainNav.classList.add('lg:rounded-b-none') }
  }

  handleMouseLeave = () => {
    if (this.mainNav) this.mainNav.classList.remove('lg:rounded-b-none')
  }
}

customElements.define('mega-nav', MegaNav)
